module.exports = __webpack_public_path__ + "static/media/gryphon_musee_everyartoriginal_3.51e7a74d.jpg";